import styled from "styled-components";

const StyledFormTextArea = styled.div`
	width: 100%;
	display: flex;
	align-items: center;

	.ant-form-item-label {
		font-size: 14px;
		> label {
			font-size: 14px;
		}
	}
	.ant-input {
		background: ${({ theme }) => theme.colors.white};
		border: 1px solid ${({ theme }) => theme.colors.iron};
		border-radius: 20px;
		padding: 4px 10px;
		min-height: 70px;
	}

	.ant-form-item {
		width: 100%;
	}

	.ant-form-item-explain-error {
		width: fit-content;
		border-radius: 100px;
		font-family: "DM Sans", sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 24px;
		color: ${({ theme }) => theme.colors.burntSienna};
	}
	textarea {
		&.ant-input {
			border-radius: 0;
		}
		resize: inline !important;
	}
	label {
		font-size: 12px;
	}
`;

export default StyledFormTextArea;

